"use client";

import { AppNudges } from "@faire/retailer-visitor-shared/features/Nudges/AppNudges";
import { useShowDeferredContent } from "@faire/web--source/common/deferredRender";
import React from "react";

export const DeferredAppNudges = () => {
  const showDeferredContent = useShowDeferredContent();
  if (!showDeferredContent) {
    return null;
  }
  return <AppNudges />;
};
